<template>
  <div class="scroll" :class="{ hidden: scrollDistance < 200 }">
    <div class="main">
      <ul class="scroll_box">
        <li
          v-for="(item, index) in images"
          :key="index"
          @mouseover="showQRCode(index)"
          @mouseleave="hideQRCode(index)"
          @click="item.onClick && item.onClick()"
        >
          <img
            class="img_tu"
            :src="showQR[index] ? item.hoverSrc : item.src"
            :alt="'Image ' + (index + 3)"
          />
          <div v-if="showQR[index]" class="hover-text" v-show="item.hoverText">
            {{ item.hoverText }}
          </div>
          <div v-if="showQR[index] && item.qr" class="qr-code">
            <img class="img_code" :src="item.qr" alt="QR Code" />
            <span class="sao_miao">扫描二维码关注我们</span>
            <div class="inverted-triangle"></div>
          </div>
        </li>
      </ul>
      <div
        @click="scrollToTop"
        class="top"
        @mouseenter="changeTextColor(true)"
        @mouseleave="changeTextColor(false)"
        :style="{ color: textColor }"
      >
        TOP
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from "vue";
import { onMounted, onUnmounted } from "vue";

// 导入图片资源
import follow_ico04b from "./../../../assets/imgs/follow_ico04b.png";
import follow_ico05b from "./../../../assets/imgs/follow_ico05b.png";
import follow_ico06b from "./../../../assets/imgs/follow_ico06b.png";
import email_icon from "./../../../assets/imgs/email.png";
import whatsapp_icon from "./../../../assets/imgs/whatsapp.png";
import qr_code_image1 from "./../../../assets/imgs/gongzonghao.jpg";
import qr_code_image2 from "./../../../assets/imgs/shipinhao.jpg";
import qr_code_image3 from "./../../../assets/imgs/douyincode.png";
import wx_white from "./../../../assets/imgs/wx_white.png";
import wxsp_white from "./../../../assets/imgs/wxsp_white.png";
import dy_white from "./../../../assets/imgs/dy_white.png";
import email_white from "./../../../assets/imgs/email_white.png";
import whatsapp_white from "./../../../assets/imgs/whatsapp_white.png";
const handleWhatsAppClick = () => {
  const phoneNumber = "021-6358 1508";
  // 移除非数字字符并添加中国国际区号(86)
  const formattedNumber = "86" + phoneNumber.replace(/[^0-9]/g, "");
  // 打开 WhatsApp
  window.open(`https://wa.me/${formattedNumber}`, "_blank");
};
// 添加邮件点击处理
const handleEmailClick = () => {
  window.open("mailto:zhangzhengyi@gylianhe.com", "_blank");
};
// 定义图片资源数组
const images = reactive([
  {
    src: wx_white,
    hoverSrc: follow_ico04b, // 悬浮时的彩色图标
    qr: qr_code_image1,
  },
  {
    src: wxsp_white,
    hoverSrc: follow_ico05b,
    qr: qr_code_image2,
  },
  {
    src: dy_white,
    hoverSrc: follow_ico06b,
    qr: qr_code_image3,
  },
  {
    src: email_white,
    hoverSrc: email_icon,
    hoverText: "zhangzhengyi@gylianhe.com",
    onClick: handleEmailClick,
  },
  {
    src: whatsapp_white,
    hoverSrc: whatsapp_icon,
    hoverText: "021-6358 1508",
    onClick: handleWhatsAppClick,
  },
]);

// 控制二维码显示状态的数组
const showQR = ref([false, false, false, false]);

// 控制文字颜色
const textColor = ref("#fff");

// 显示指定序号的二维码并替换图片
const showQRCode = (index: number) => {
  showQR.value[index] = true;
  // images[index].src = images[index].replaceSrc;
};

// 隐藏指定序号的二维码并恢复原始图片
const hideQRCode = (index: number) => {
  showQR.value[index] = false;
  // images[index].src = images[index].originalSrc;
};

// 点击回到顶部
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// 变量用于存储滚动距离
const scrollDistance = ref(0);

// 滚动事件中更新滚动距离
const updateScrollDistance = () => {
  scrollDistance.value = window.scrollY;
};

// 监听滚动事件
onMounted(() => {
  window.addEventListener("scroll", updateScrollDistance);
});

// 组件卸载时移除滚动事件监听器
onUnmounted(() => {
  window.removeEventListener("scroll", updateScrollDistance);
});

// 改变文字颜色
const changeTextColor = (isMouseOver: boolean) => {
  textColor.value = isMouseOver ? "#004080" : "#fff";
};
</script>

<style scoped lang="scss">
.main {
  position: fixed;
  text-align: center;
  z-index: 999999;
  top: 65%;
  right: 3%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-50%);
}
.scroll_box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 50px;
  border-radius: 15px;
  background-color: #a1a1a1;
  color: #fff;
  margin-bottom: 20px;
  padding: 20px 0;
}

li {
  cursor: pointer;
  margin-bottom: 15px;
  position: relative;
  width: 40px;
  height: 40px;
  display: flex; // 添加flex布局
  align-items: center; // 垂直居中
  justify-content: center; // 水平居中
}

.img_tu {
  width: 80%;
  height: 80%;
  object-fit: contain;
}

.hover-text {
  position: absolute;
  right: 130%;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  padding: 10px 15px;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  color: #004080;
  font-size: 14px;
  white-space: nowrap;
  z-index: 1000;
  height: 20px; // 添加固定高度
  line-height: 20px; // 添加行高
  display: flex; // 使用flex布局
  align-items: center; // 垂直居中

  &:after {
    content: "";
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    border-left: 8px solid #fff;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
  }
}

.qr-code {
  position: absolute;
  right: 150%;
  top: -150%;
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: none;
  z-index: 1000;

  .img_code {
    width: 120px;
    height: 120px;
    object-fit: cover;
    display: block;
  }

  .sao_miao {
    display: block;
    margin-top: 10px;
    color: #333;
    font-size: 12px;
    text-align: center;
    line-height: 1.4;
  }

  .inverted-triangle {
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid #fff;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
  }
}

li:hover .qr-code {
  display: block;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.top {
  position: absolute;
  left: 0;
  top: 100%;
  font-size: 20px;
  line-height: 50px;
  width: 50px;
  height: 50px;
  background-color: #a1a1a1;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    color: #004080 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }
}

.hidden {
  display: none;
}
</style>